import { messageError } from '../../components/message';
import {
  OLD_SUPPORT_ACCOUNT_PREFIX,
  SUPPORT_ACCOUNT_POSTFIX,
} from '../../config/user';
import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType, IRBACRole, IRBACUserGroup } from '../../model';
import {
  IAPIStudioMemberHasPermissionItem,
  IRbacMemberItem,
} from '../../model/api-modules';
import { ADMIN_PREFIX } from '../config';

export const adminGetStudioMembersHasPermission = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/studio/${studioId}/members-roles`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<
        Array<IAPIStudioMemberHasPermissionItem>
      >(response, 'data');
      return res.filter(
        (item) => !item.UserID.endsWith(SUPPORT_ACCOUNT_POSTFIX)
      );
    } catch (error) {
      return [];
    }
  });

export const adminBatchGetStudioMembers = (studioIds: string[]) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/studio/batch-members?studios=${studioIds.join()}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<Record<string, Array<IRbacMemberItem>>>(
        response,
        'data'
      );
      return res;
    } catch (error) {
      return {};
    }
  });
// 获取用户组列表
export const adminGetUserGroupsList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const supportUserGroupPrefix = 'supportAccReq_userGroup';
      const url = `${ADMIN_PREFIX}/rbac/user-group?studioID=${studioId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ReadonlyArray<IRBACUserGroup>>(
        response,
        'data'
      );
      return res
        .filter((item) => !item.groupName.startsWith(supportUserGroupPrefix))
        .map((groupData) => {
          return {
            ...groupData,
            members: groupData.members?.filter(
              (member) =>
                !member.startsWith(OLD_SUPPORT_ACCOUNT_PREFIX) &&
                !member.endsWith(SUPPORT_ACCOUNT_POSTFIX)
            ),
          };
        });
    } catch (error) {
      console.log(error);
      return null;
    }
  });

// 获取角色列表
export const adminGetRolesList = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const supportRolePrefix = 'supportAccReq_role';
      const url = `${ADMIN_PREFIX}/rbac/role?studioID=${studioId}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<ReadonlyArray<IRBACRole>>(
        response,
        'data'
      );
      return res.filter((item) => !item.roleName.startsWith(supportRolePrefix));
    } catch (error) {
      console.log(error);
      return null;
    }
  });

export const adminDeleteStudio = (studioId: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${ADMIN_PREFIX}/studio/${studioId}`;
      const response = await api.commonRequest('DELETE', url);
      await parsedResponse<ReadonlyArray<IRBACRole>>(response, 'data');
      return true;
    } catch (error) {
      if (error instanceof APIError) {
        messageError(error?.apiError?.message);
      }
      return false;
    }
  });
